import React from 'react';
import ReactGA from 'react-ga';
import './error.css';

class NotSubscribedError extends React.Component {

    render(){
        return (
            <div className="error-message-container container">
                <div className="inner-error-container">
                    <h2 className="mb-4">Learn more about Common App Insight</h2>

                    <div className="error-message">
                        <p>
                            Harness the power of your data with <ReactGA.OutboundLink eventLabel="control-center-sign-in" to="https://www.commonapp.org/insight">Common App Insight</ReactGA.OutboundLink>.
                            Visualize applicant trends and identify patterns at your institution to shape your enrollment strategies. Contact your Member Relations Manager to schedule a demo.
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default NotSubscribedError;



// WEBPACK FOOTER //
// ./src/components/errorPage/NotSubscribedError.jsx